import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class Modal extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return ReactDOM.createPortal((
			<React.Fragment>
				<div className="Modal modal-backdrop fade show"></div>
				<div className="modal fade d-block show" tabIndex="-1" role="dialog">
					<div className="modal-dialog modal-lg" role="document">
						<div className="modal-content">
							{this.props.header &&
								<div className="modal-header">
									<h5 className="modal-title">{this.props.header}</h5>
								</div>
							}
							<div className="modal-body">
								{this.props.children}
							</div>
							<div className="modal-footer">
								{this.props.footer}
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		),
		document.getElementById('modal')
		);
	}
}

Modal.propTypes = {
	header: PropTypes.any,
	children: PropTypes.any,
	footer: PropTypes.any
};


export default Modal;
